import IconButton from '@/global/components/Button/IconButton'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import DialogConfirmar from '@/global/guides/Dialog/DialogConfirmar'
import { UserRoundMinusIcon } from 'lucide-react'
import { useState } from 'react'
import { reps } from 'service/api'
import { toast } from 'sonner'

export const DesassociarFuncionarioRep: React.FC<GridCellParams> = ({
    row,
}) => {
    const [open, setOpen] = useState(false)
    const { mutate } = reps.funcionarios.mutations.useDelete({
        invalidateQuery: true,
    })

    function handleSubmit() {
        mutate(row.id, {
            onSuccess: async () => {
                setOpen(false)
                toast.success('Funcionário desassociado com sucesso')
            },
        })
    }

    return [
        <IconButton
            key="desassociar"
            onClick={() => setOpen(true)}
            title="Desassociar"
        >
            <UserRoundMinusIcon className="text-error" />
        </IconButton>,
        <DialogConfirmar
            key="confirmar"
            open={open}
            onClose={() => setOpen(false)}
            onConfirm={handleSubmit}
            title="Tem certeza que deseja desassociar o funcionario a este REP?"
        />,
    ]
}
